export default "__VITE_ASSET__CCq8pW$___"